import React, { useState, useEffect } from 'react';
import { Table, Grid, TableHead, TableRow, TableCell, TableBody, TextField, Paper, Button, IconButton, Tooltip } from '@material-ui/core';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { globalGetService, globalPostService, globalPutService } from '../../../globalServices';
import EditIcon from '@material-ui/icons/Edit';
import moment from 'moment';
import { backendDateFormat, fieldDateFormat } from '../../../constants';
import { withRouter } from 'react-router';
import { checkApiStatus, checkPermission, replaceEmptyNumberZero, replaceEmptyWithNull } from '../../utils_v2';
import { useSnackbar } from 'notistack';
import { regexConstants } from '../../../constants/regEx';
import { weightObj } from '..';
import { PageLoader, STableLoader } from '../../shared_elements';
import { Skeleton } from '@material-ui/lab';
import { trackActivity } from '../../../utils/mixpanel';
import { avationPlcInstance, titanAviInstance, mtInstance, gaTelesisInstance } from '../../../shared/components';
import { InfoOutlined } from '@material-ui/icons';
import { numberWithCommas } from '../../../utils';
const WeightRowItem = ({ isEdit, keyParam, onFieldChange, error, kgsValue, lbsValue, weightLimits,setError }) => {
const getTooltipText = (keyParam, isKgs, weightLimits) => {
    if (!weightLimits || !Array.isArray(weightLimits)) return '';
    const weightTypeMap = { basic_empty_weight: 1, max_landing_weight: 2, max_take_off_weight: 3, max_taxi_weight: 4, max_zero_fuel_weight: 5, manufacturers_empty_weight: 6, operational_empty_weight:7 };
    const type = keyParam.split('_').slice(1).join('_').replace('_kgs', '');
    const weightType = weightTypeMap[type];
    if (!weightType) return '';

    const limit = weightLimits.find(item => item.weight_type?.value === weightType);
    if (!limit) return '';

    const unit = isKgs ? 'kgs' : 'lbs';
    const min = isKgs ? limit.min_weight_kgs : limit.min_weight_lbs;
    const max = isKgs ? limit.max_weight_kgs : limit.max_weight_lbs;
    if (min != null && max != null) {
        return `Value must be between ${min} and ${max} ${unit}`;
    } else if (min != null) {
        return `Value must be greater than or equal to ${min} ${unit}`;
    } else if (max != null) {
        return `Value must be less than or equal to ${max} ${unit}`;
    }
    return '';
};
    const displayValue = (value) => !isEdit && value !== '' && value !== null && value !== undefined ? numberWithCommas(value) : value;

    return (
        <TableCell className='content-cell'>
            <Table className='inner-table'>
                <TableRow>
                    <TableCell>
                        <TextField
                            disabled={!isEdit}
                            fullWidth
                            margin="normal"
                            value={displayValue(lbsValue)}
                            error={!!error?.[`${keyParam}`]}
                            onFocus={() => setError(prev => ({ ...prev, [keyParam]: '' }))}
                            label={
                                <div>
                                    <Tooltip title={getTooltipText(keyParam, false, weightLimits)}>
                                        <InfoOutlined color='primary' fontSize='small' />
                                    </Tooltip>
                                </div>
                            }
                            InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                            variant='outlined'
                            onChange={(e) => regexConstants.decimalnodotstart3.test(e.target.value) ? onFieldChange(keyParam, e.target.value) : e.preventDefault()}
                        />
                    </TableCell>
                    <TableCell>
                        <TextField
                            disabled={!isEdit}
                            fullWidth
                            margin="normal"
                            value={displayValue(kgsValue)}
                            error={!!error?.[`${keyParam}`]}
                            onFocus={() => setError(prev => ({ ...prev, [keyParam]: '' }))}
                            label={
                                <div>
                                    <Tooltip title={getTooltipText(keyParam, true, weightLimits)}>
                                        <InfoOutlined color='primary' fontSize='small' />
                                    </Tooltip>
                                </div>
                            }
                            InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                            variant='outlined'
                            onChange={(e) => regexConstants.decimalnodotstart3.test(e.target.value) ? onFieldChange(`${keyParam}_kgs`, e.target.value) : e.preventDefault()}
                        />
                    </TableCell>
                </TableRow>
            </Table>
        </TableCell>
    )
}
const WeightRemarksItem = ({ isEdit, keyParam, onFieldChange, remarksValue }) => {
    return (
        <TableCell className='content-cell' style={{width:'250px'}}>
            <Table className='inner-table'>
                <TableRow>
                    <TableCell>
                        <TextField
                            disabled={!isEdit}
                            fullWidth
                            margin="normal"
                            value={remarksValue || ''}
                            onChange={(e) => onFieldChange(`${keyParam}`, e.target.value)}
                            multiline
                            rows={2}
                            variant="outlined"
                            inputProps={{maxLength:'40'}}
                            InputLabelProps={{ shrink: true }}
                        />
                    </TableCell>
                </TableRow>
            </Table>
        </TableCell>
    );
};

const AircraftWeight = ({ params, assetInfoData }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [isEdit, setEdit] = useState(false);
    const [weightDetails, setWeightDetails] = useState({});
    const [weightConstant, setWeightConstant] = useState({})
    const [weightLimits, setWeightLimits] = useState({})
    const [error, setError] = useState({});
    useEffect(() => {
        getWeightDetails('skeletonLoader');
        getWeightConstant()
        getWeightLimits()
    }, []);
    const getWeightDetails = (loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(`console/v2/asset/${params.type}/${params.aircraft_slug}/weight_variants/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setWeightDetails(response.data.data);
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
            })
    }
    const getWeightConstant = () => {
        globalPostService('console/get-constants/', { constant_types: ['weight_unit'] })
            .then(response => {
                if (checkApiStatus(response)) {
                    setWeightConstant(response.data.data)
                }
            })
    }
    const getWeightLimits = () => {
        globalGetService('/console/weight-variant-limits/', { aircraft_type_id: assetInfoData?.aircraft_type?.id })
            .then(response => {
                if (checkApiStatus(response)) {
                    setWeightLimits(response.data.data)
                }
            })
    }
    const formatLabel = (key) => {
        const parts = key.split('_');
        const typeMap = {
            purchase: 'Purchased',
            delivered: 'Delivered',
            operating: 'Current'
        };

        const labelMap = {
            basic_empty_weight: 'Basic Empty Weight',
            max_landing_weight: 'Max Landing Weight',
            max_take_off_weight: 'Max Take Off Weight',
            max_taxi_weight: 'Max Taxi Weight',
            max_zero_fuel_weight: 'Max Zero Fuel Weight',
            manufacturers_empty_weight: 'Manufacturers Empty Weight',
            operational_empty_weight: 'Operational Empty Weight'
        };

        const prefix = typeMap[parts[0]] || parts[0];
        const suffixKey = parts.slice(1).join('_').replace('_kgs', '');
        const suffix = labelMap[suffixKey] || suffixKey;

        return `${prefix} ${suffix}`;
    };
    const editWeightDetails = () => {
        let validationInputs = {
            date_last_weighing: weightDetails?.date_last_weighing && !mtInstance ? moment(weightDetails.date_last_weighing).isSameOrAfter(assetInfoData?.date_of_manufacture, 'day') ? '' : "Date Last Weighing cannot be lesser than Date Of Manufacture" : '',
            last_weighing_report_date: weightDetails?.last_weighing_report_date && !mtInstance ? moment(weightDetails.last_weighing_report_date).isSameOrAfter(assetInfoData?.date_of_manufacture, 'day') ? '' : "Last Weighing report Date cannot be lesser than Date Of Manufacture" : '',
        }
        if (weightDetails.date_last_weighing && !moment(weightDetails.date_last_weighing).isValid()) {
            validationInputs = {
                ...validationInputs,
                date_last_weighing: "Enter valid Date Last Weighing"
            }
        }
        if (weightDetails.last_weighing_report_date && !moment(weightDetails.last_weighing_report_date).isValid()) {
            validationInputs = {
                ...validationInputs,
                last_weighing_report_date: "Enter valid Last Weighing Report Date"
            }
        }
        const weightTypeKeys = [ 'basic_empty_weight', 'max_landing_weight', 'max_take_off_weight', 'max_taxi_weight', 'max_zero_fuel_weight', 'manufacturers_empty_weight', 'operational_empty_weight' ];
        weightTypeKeys.forEach((typeKey, index) => {
            const weightType = index + 1;
            const keys = ['purchase', 'delivered', 'operating'].map(prefix => `${prefix}_${typeKey}`);
            const limit = weightLimits?.find?.(item => item?.weight_type?.value === weightType);
            if (typeKey === 'manufacturers_empty_weight' && !(titanAviInstance||avationPlcInstance||mtInstance)) return;
            if (limit) {
                keys.forEach(key => {
                    const lbsVal = parseFloat(weightDetails[key]);
                    const kgsVal = parseFloat(weightDetails[`${key}_kgs`]);

                    let lbsError = '';
                    let kgsError = '';

                    if (!isNaN(lbsVal)) {
                        if (limit.min_weight_lbs != null && limit.max_weight_lbs == null) {
                            if (lbsVal < limit.min_weight_lbs) {
                                lbsError = `${formatLabel(key)} must be greater than or equal to ${limit.min_weight_lbs} lbs`;
                            }
                        } else if (limit.max_weight_lbs != null && limit.min_weight_lbs == null) {
                            if (lbsVal > limit.max_weight_lbs) {
                                lbsError = `${formatLabel(key)} must be less than or equal to ${limit.max_weight_lbs} lbs`;
                            }
                        } else if (limit.min_weight_lbs != null && limit.max_weight_lbs != null) {
                            if (lbsVal < limit.min_weight_lbs || lbsVal > limit.max_weight_lbs) {
                                lbsError = `${formatLabel(key)} must be between ${limit.min_weight_lbs}–${limit.max_weight_lbs} lbs`;
                            }
                        }
                    }
                    if (!isNaN(kgsVal)) {
                        if (limit.min_weight_kgs != null && limit.max_weight_kgs == null) {
                            if (kgsVal < limit.min_weight_kgs) {
                                kgsError = `${formatLabel(key)} must be greater than or equal to ${limit.min_weight_kgs} kgs`;
                            }
                        } else if (limit.max_weight_kgs != null && limit.min_weight_kgs == null) {
                            if (kgsVal > limit.max_weight_kgs) {
                                kgsError = `${formatLabel(key)} must be less than or equal to ${limit.max_weight_kgs} kgs`;
                            }
                        } else if (limit.min_weight_kgs != null && limit.max_weight_kgs != null) {
                            if (kgsVal < limit.min_weight_kgs || kgsVal > limit.max_weight_kgs) {
                                kgsError = `${formatLabel(key)} must be between ${limit.min_weight_kgs}–${limit.max_weight_kgs} kgs`;
                            }
                        }
                    }

                    if (lbsError || kgsError) {
                        validationInputs[key] = [lbsError, kgsError].filter(Boolean).join(' & ');
                    }
                });
            }
        });

        const errorMessages = Object.values(validationInputs).filter(msg => !!msg);

        if (errorMessages.length) {
            setError(validationInputs); 
            enqueueSnackbar(`\n${errorMessages.map(msg => `${msg}`).join('\n')}`, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
            return;
        }
        const TitanRemarks = replaceEmptyWithNull(
            weightDetails?.titan_weight_remarks || {},
            ['remarks_basic_empty_weight', 'remarks_max_landing_weight', 'remarks_max_take_off_weight', 'remarks_max_taxi_weight', 'remarks_max_zero_fuel_weight', 'remarks_manufacturers_empty_weight' ]
        );

        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true);
            let payload = Object.assign({}, weightDetails);
            payload = {
                ...payload,
                titan_weight_remarks: TitanRemarks
            }            
            globalPutService(`console/v2/asset/${params.type}/${params.aircraft_slug}/weight_variants/`, replaceEmptyNumberZero(payload, ['purchase_max_zero_fuel_weight', 'fuel_capacity_gal', 'fuel_capacity', 'fuel_capacity_density', 'purchase_max_zero_fuel_weight_kgs', 'purchase_basic_operating_weight', 'purchase_basic_operating_weight_kgs', 'purchase_max_take_off_weight', 'purchase_max_take_off_weight_kgs', 'purchase_max_landing_weight', 'purchase_max_landing_weight_kgs', 'purchase_max_taxi_weight', 'purchase_max_taxi_weight_kgs', 'purchase_basic_empty_weight',
                'purchase_basic_empty_weight_kgs', 'operating_max_zero_fuel_weight', 'operating_max_zero_fuel_weight_kgs', 'operating_max_take_off_weight', 'operating_max_take_off_weight_kgs', 'operating_max_landing_weight', 'operating_max_landing_weight_kgs', 'operating_max_taxi_weight', 'operating_max_taxi_weight_kgs', 'operating_basic_empty_weight', 'operating_basic_empty_weight_kgs', 'operating_basic_operating_weight', 'operating_basic_operating_weight_kgs', 'delivered_max_zero_fuel_weight',
                'delivered_max_zero_fuel_weight_kgs', 'delivered_max_take_off_weight', 'delivered_max_take_off_weight_kgs', 'delivered_max_landing_weight', 'delivered_max_landing_weight_kgs', 'delivered_max_taxi_weight', 'delivered_max_taxi_weight_kgs', 'delivered_basic_empty_weight', 'delivered_basic_empty_weight_kgs', 'delivered_basic_operating_weight',
                'delivered_basic_operating_weight_kgs', 'purchase_manufacturers_empty_weight_kgs', 'delivered_manufacturers_empty_weight_kgs', 'operating_manufacturers_empty_weight_kgs', 'purchase_manufacturers_empty_weight', 'delivered_manufacturers_empty_weight', 'operating_manufacturers_empty_weight', "delivered_operational_empty_weight", "delivered_operational_empty_weight_kgs", "operating_operational_empty_weight", "operating_operational_empty_weight_kgs", "purchase_operational_empty_weight", "purchase_operational_empty_weight_kgs","remarks_operational_empty_weight"]))
                .then(response => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                        trackActivity('Console Management', {data:JSON.stringify(payload), page_title: 'Aircraft Weight Details', asset_type: 'MSN', asset_name: assetInfoData?.serial_number, event_type: 'Item Edited', event_desc: 'Edited Aircraft Weight Details data from Edit Aircraft Weight Details form' });
                        setEdit(false);
                        getWeightDetails('skeletonLoader');
                    }
                    setLoading(false)
                })
        } else {
            setError(validationInputs)
        }
    }
    const onFieldChange = (key, value) => {
        if (key === 'fuel_capacity' && !titanAviInstance) {
            setWeightDetails({
                ...weightDetails,
                [key]: value,
                fuel_capacity_gal: parseFloat(parseFloat(value * 0.2641720524).toFixed(2))
            })
        } else if (key === 'fuel_capacity_gal' && !titanAviInstance) {
            setWeightDetails({
                ...weightDetails,
                [key]: value,
                fuel_capacity: parseFloat(parseFloat(value * 3.785411784).toFixed(2))
            });
        } else {
            setWeightDetails({ ...weightDetails, [key]: value });
        }
    }
    const updateWeights = (key, value) => {
        let conversionFactor = 0.45359237;
        if (titanAviInstance) {
            setWeightDetails({ ...weightDetails, [key]: value });
        } else {
            if (key?.includes('_kgs')) {
                let lbKey = key.substr(0, key.indexOf('_kg'));
                setWeightDetails({
                    ...weightDetails,
                    [key]: value,
                    [lbKey]: parseFloat((value * (1 / conversionFactor)).toFixed(3))
                });
            } else {
                let kgKey = key + '_kgs';
                setWeightDetails({
                    ...weightDetails,
                    [key]: value,
                    [kgKey]: parseFloat((value * conversionFactor).toFixed(3))
                });
            }
        }
    };
    const updateRemark = (key, value) => {
            setWeightDetails((prev) => ({ 
                ...prev, 
                titan_weight_remarks: { ...prev?.titan_weight_remarks, [key]: value } 
            }));
    };
    return (
        <div style={{ position: 'relative' }}>
            <div className='console-forms-fields' style={{ padding: '10px', height: `${window.innerHeight - 220}px`, overflow: 'auto' }}>
                <p style={{ textAlign: 'right', height: '20px' }}>
                    {checkPermission('technical_specs', 'aircraft', 'U') && !isEdit ?
                        <span style={{ cursor: 'pointer' }}>
                            <EditIcon onClick={() => { setEdit(true); }} fontSize="small" color='primary' />
                        </span> : null
                    }
                </p>
                {skeletonLoader ? <STableLoader count={4}/> : <>
                    <Grid container spacing={1}>
                   
                        <Grid item md={3}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <KeyboardDatePicker
                                    disabled={!isEdit}
                                    margin="normal"
                                    name="date_last_weighing"
                                    label="Date Last Weighing"
                                    format={fieldDateFormat}
                                    fullWidth
                                    disableFuture={mtInstance?false:true}
                                    InputLabelProps={{ shrink: true }}
                                    minDate={!mtInstance ? assetInfoData.date_of_manufacture : undefined}
                                    value={weightDetails?.date_last_weighing || null}
                                    onChange={(data, value) => { onFieldChange('date_last_weighing', data ? moment(data).format(backendDateFormat) : null); setError({ ...error, 'date_last_weighing': '' }) }}
                                    inputVariant='outlined'
                                    error={error?.date_last_weighing ? true : false}
                                    helperText={error?.date_last_weighing || ''}
                                // onFocus={() => setError({ ...error, 'date_last_weighing': '' })}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={3}>
                            <TextField
                                disabled={!isEdit}
                                name='weight_variant'
                                label='Weight Variant'
                                value={weightDetails?.weight_variant || ''}
                                fullWidth
                                margin="normal"
                                inputProps={{ maxLength: 25 }}
                                onChange={(e) => onFieldChange('weight_variant', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>
                        { gaTelesisInstance ? <Grid item md={6}>
                            <TextField
                                disabled={!isEdit}
                                name='weight_remarks'
                                label='Notes'
                                value={weightDetails?.weight_remarks || ''}
                                fullWidth
                                margin="normal"
                                inputProps={{ maxLength: 100 }}
                                onChange={(e) => onFieldChange('weight_remarks', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>:null}
                        {(titanAviInstance||avationPlcInstance||mtInstance) ?<>
                        <Grid item md={12}>
                            <TextField
                                disabled={!isEdit}
                                name='weight_remarks'
                                label='Remarks'
                                value={weightDetails?.weight_remarks || ''}
                                fullWidth
                                margin="normal"
                                rows={5}
                                multiline
                                onChange={(e) => onFieldChange('weight_remarks', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={3}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardDatePicker
                                        disabled={!isEdit}
                                        margin="normal"
                                        name="last_weighing_report_date"
                                        label="Last Weighing Report Date"
                                        format={fieldDateFormat}
                                        fullWidth
                                        disableFuture={mtInstance?false:true}
                                        InputLabelProps={{ shrink: true }}
                                        minDate={!mtInstance ? assetInfoData.date_of_manufacture : undefined}
                                        value={weightDetails?.last_weighing_report_date || null}
                                        onChange={(data, value) => { onFieldChange('last_weighing_report_date', data? moment(data).format(backendDateFormat) : null); setError({ ...error, 'last_weighing_report_date': '' }) }}
                                        inputVariant='outlined'
                                        error={error?.last_weighing_report_date ? true : false}
                                        helperText={error?.last_weighing_report_date || ''}
                                    // onFocus={() => setError({ ...error, 'date_last_weighing': '' })}
                                    />
                                </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={12}>
                            <TextField
                                disabled={!isEdit}
                                name='last_weighing_report_remarks'
                                label='Last Weighing Report Remarks'
                                value={weightDetails?.last_weighing_report_remarks || ''}
                                fullWidth
                                margin="normal"
                                rows={5}
                                multiline
                                onChange={(e) => onFieldChange('last_weighing_report_remarks', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid></> : null}
                    </Grid>
                    <div className='console-weight-forms-fields aircraft-weight-table' style={{ paddingTop: '25px' }}>
                        <Paper >
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className='header-cell-border' style={{ pointerEvents: 'none' }}></TableCell>
                                        {['Purchased', 'Delivered', 'Current'].map((label, index) =>
                                            <TableCell key={index} className='header-cell-border' style={{ pointerEvents: 'none' }}>
                                                <p>{label}</p>
                                                <Table className='inner-table-hd' style={{ pointerEvents: 'none' }}>
                                                    <TableRow>
                                                        <TableCell >{weightConstant[1]?.label}</TableCell>
                                                        <TableCell>{weightConstant[0]?.label}</TableCell>
                                                    </TableRow>
                                                </Table>
                                            </TableCell>
                                        )}
                                        {titanAviInstance?<TableCell className='header-cell-border inner-table-hd' style={{ pointerEvents: 'none', textAlignLast:'center' }}> Remarks </TableCell>:null}
                                    </TableRow>
                                </TableHead>
                                <TableBody >
                                    <TableRow>
                                        <TableCell style={{ backgroundColor: "#b6bedc" }}>Basic Empty Weight</TableCell>
                                        <WeightRowItem setError={setError} error={error} weightLimits={weightLimits} isEdit={isEdit} keyParam='purchase_basic_empty_weight' onFieldChange={(key, value) => updateWeights(key, value)} kgsValue={weightDetails.purchase_basic_empty_weight_kgs} lbsValue={weightDetails.purchase_basic_empty_weight} />
                                        <WeightRowItem setError={setError} error={error} weightLimits={weightLimits} isEdit={isEdit} keyParam='delivered_basic_empty_weight' onFieldChange={(key, value) => updateWeights(key, value)} kgsValue={weightDetails.delivered_basic_empty_weight_kgs} lbsValue={weightDetails.delivered_basic_empty_weight} />
                                        <WeightRowItem setError={setError} error={error} weightLimits={weightLimits} isEdit={isEdit} keyParam='operating_basic_empty_weight' onFieldChange={(key, value) => updateWeights(key, value)} kgsValue={weightDetails.operating_basic_empty_weight_kgs} lbsValue={weightDetails.operating_basic_empty_weight} />
                                        {titanAviInstance?<WeightRemarksItem isEdit={isEdit} keyParam="remarks_basic_empty_weight" onFieldChange={(key, value) => updateRemark(key, value)} remarksValue={weightDetails?.titan_weight_remarks?.['remarks_basic_empty_weight']} />:null}
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ backgroundColor: "#b6bedc" }}>Max Landing Weight</TableCell>
                                        <WeightRowItem setError={setError} error={error} weightLimits={weightLimits} isEdit={isEdit} keyParam='purchase_max_landing_weight' onFieldChange={(key, value) => updateWeights(key, value)} kgsValue={weightDetails.purchase_max_landing_weight_kgs} lbsValue={weightDetails.purchase_max_landing_weight} />
                                        <WeightRowItem setError={setError} error={error} weightLimits={weightLimits} isEdit={isEdit} keyParam='delivered_max_landing_weight' onFieldChange={(key, value) => updateWeights(key, value)} kgsValue={weightDetails.delivered_max_landing_weight_kgs} lbsValue={weightDetails.delivered_max_landing_weight} />
                                        <WeightRowItem setError={setError} error={error} weightLimits={weightLimits} isEdit={isEdit} keyParam='operating_max_landing_weight' onFieldChange={(key, value) => updateWeights(key, value)} kgsValue={weightDetails.operating_max_landing_weight_kgs} lbsValue={weightDetails.operating_max_landing_weight} />
                                        {titanAviInstance?<WeightRemarksItem isEdit={isEdit} keyParam="remarks_max_landing_weight" onFieldChange={(key, value) => updateRemark(key, value)} remarksValue={weightDetails?.titan_weight_remarks?.['remarks_max_landing_weight']} />:null}
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ backgroundColor: "#b6bedc" }}>Max Take Off Weight</TableCell>
                                        <WeightRowItem setError={setError} error={error} weightLimits={weightLimits} isEdit={isEdit} keyParam='purchase_max_take_off_weight' onFieldChange={(key, value) => updateWeights(key, value)} kgsValue={weightDetails.purchase_max_take_off_weight_kgs} lbsValue={weightDetails.purchase_max_take_off_weight} />
                                        <WeightRowItem setError={setError} error={error} weightLimits={weightLimits} isEdit={isEdit} keyParam='delivered_max_take_off_weight' onFieldChange={(key, value) => updateWeights(key, value)} kgsValue={weightDetails.delivered_max_take_off_weight_kgs} lbsValue={weightDetails.delivered_max_take_off_weight} />
                                        <WeightRowItem setError={setError} error={error} weightLimits={weightLimits} isEdit={isEdit} keyParam='operating_max_take_off_weight' onFieldChange={(key, value) => updateWeights(key, value)} kgsValue={weightDetails.operating_max_take_off_weight_kgs} lbsValue={weightDetails.operating_max_take_off_weight} />
                                        {titanAviInstance?<WeightRemarksItem isEdit={isEdit} keyParam="remarks_max_take_off_weight" onFieldChange={(key, value) => updateRemark(key, value)} remarksValue={weightDetails?.titan_weight_remarks?.['remarks_max_take_off_weight']} />:null}
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ backgroundColor: "#b6bedc" }}>Max Taxi Weight</TableCell>
                                        <WeightRowItem setError={setError} error={error} weightLimits={weightLimits} isEdit={isEdit} keyParam='purchase_max_taxi_weight' onFieldChange={(key, value) => updateWeights(key, value)} kgsValue={weightDetails.purchase_max_taxi_weight_kgs} lbsValue={weightDetails.purchase_max_taxi_weight} />
                                        <WeightRowItem setError={setError} error={error} weightLimits={weightLimits} isEdit={isEdit} keyParam='delivered_max_taxi_weight' onFieldChange={(key, value) => updateWeights(key, value)} kgsValue={weightDetails.delivered_max_taxi_weight_kgs} lbsValue={weightDetails.delivered_max_taxi_weight} />
                                        <WeightRowItem setError={setError} error={error} weightLimits={weightLimits} isEdit={isEdit} keyParam='operating_max_taxi_weight' onFieldChange={(key, value) => updateWeights(key, value)} kgsValue={weightDetails.operating_max_taxi_weight_kgs} lbsValue={weightDetails.operating_max_taxi_weight} value={weightDetails.operating_max_taxi_weight === null ? '' : weightDetails.operating_max_taxi_weight} />
                                        {titanAviInstance?<WeightRemarksItem isEdit={isEdit} keyParam="remarks_max_taxi_weight" onFieldChange={(key, value) => updateRemark(key, value)} remarksValue={weightDetails?.titan_weight_remarks?.['remarks_max_taxi_weight']} />:null}
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ backgroundColor: "#b6bedc" }}>Max Zero Fuel Weight</TableCell>
                                        <WeightRowItem setError={setError} error={error} weightLimits={weightLimits} isEdit={isEdit} keyParam='purchase_max_zero_fuel_weight' onFieldChange={(key, value) => updateWeights(key, value)} kgsValue={weightDetails.purchase_max_zero_fuel_weight_kgs} lbsValue={weightDetails.purchase_max_zero_fuel_weight} />
                                        <WeightRowItem setError={setError} error={error} weightLimits={weightLimits} isEdit={isEdit} keyParam='delivered_max_zero_fuel_weight' onFieldChange={(key, value) => updateWeights(key, value)} kgsValue={weightDetails.delivered_max_zero_fuel_weight_kgs} lbsValue={weightDetails.delivered_max_zero_fuel_weight} />
                                        <WeightRowItem setError={setError} error={error} weightLimits={weightLimits} isEdit={isEdit} keyParam='operating_max_zero_fuel_weight' onFieldChange={(key, value) => updateWeights(key, value)} kgsValue={weightDetails.operating_max_zero_fuel_weight_kgs} lbsValue={weightDetails.operating_max_zero_fuel_weight} />
                                        {titanAviInstance?<WeightRemarksItem isEdit={isEdit} keyParam="remarks_max_zero_fuel_weight" onFieldChange={(key, value) => updateRemark(key, value)} remarksValue={weightDetails?.titan_weight_remarks?.['remarks_max_zero_fuel_weight']} />:null}
                                    </TableRow>
                                    {(titanAviInstance || avationPlcInstance || mtInstance) ?
                                        <TableRow>
                                            <TableCell style={{ backgroundColor: "#b6bedc" }}>Manufacturers Empty Weight</TableCell>
                                            <WeightRowItem setError={setError} error={error} weightLimits={weightLimits} isEdit={isEdit} keyParam='purchase_manufacturers_empty_weight' onFieldChange={(key, value) => updateWeights(key, value)} kgsValue={weightDetails?.purchase_manufacturers_empty_weight_kgs} lbsValue={weightDetails?.purchase_manufacturers_empty_weight} />
                                            <WeightRowItem setError={setError} error={error} weightLimits={weightLimits} isEdit={isEdit} keyParam='delivered_manufacturers_empty_weight' onFieldChange={(key, value) => updateWeights(key, value)} kgsValue={weightDetails?.delivered_manufacturers_empty_weight_kgs} lbsValue={weightDetails?.delivered_manufacturers_empty_weight} />
                                            <WeightRowItem setError={setError} error={error} weightLimits={weightLimits} isEdit={isEdit} keyParam='operating_manufacturers_empty_weight' onFieldChange={(key, value) => updateWeights(key, value)} kgsValue={weightDetails?.operating_manufacturers_empty_weight_kgs} lbsValue={weightDetails?.operating_manufacturers_empty_weight} />
                                            {titanAviInstance?<WeightRemarksItem isEdit={isEdit} keyParam="remarks_manufacturers_empty_weight" onFieldChange={(key, value) => updateRemark(key, value)} remarksValue={weightDetails?.titan_weight_remarks?.['remarks_manufacturers_empty_weight']} />:null}
                                        </TableRow> : null}
                                        <TableRow>
                                        <TableCell style={{ backgroundColor: "#b6bedc" }}>Operational Empty Weight</TableCell>
                                        <WeightRowItem setError={setError} error={error} weightLimits={weightLimits} isEdit={isEdit} keyParam='purchase_operational_empty_weight' onFieldChange={(key, value) => updateWeights(key, value)} kgsValue={weightDetails.purchase_operational_empty_weight_kgs} lbsValue={weightDetails.purchase_operational_empty_weight} />
                                        <WeightRowItem setError={setError} error={error} weightLimits={weightLimits} isEdit={isEdit} keyParam='delivered_operational_empty_weight' onFieldChange={(key, value) => updateWeights(key, value)} kgsValue={weightDetails.delivered_operational_empty_weight_kgs} lbsValue={weightDetails.delivered_operational_empty_weight} />
                                        <WeightRowItem setError={setError} error={error} weightLimits={weightLimits} isEdit={isEdit} keyParam='operating_operational_empty_weight' onFieldChange={(key, value) => updateWeights(key, value)} kgsValue={weightDetails.operating_operational_empty_weight_kgs} lbsValue={weightDetails.operating_operational_empty_weight} />
                                        {titanAviInstance?<WeightRemarksItem isEdit={isEdit} keyParam="remarks_operational_empty_weight" onFieldChange={(key, value) => updateRemark(key, value)} remarksValue={weightDetails?.titan_weight_remarks?.['remarks_operational_empty_weight']} />:null}
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Paper>
                    </div></>}
                {isEdit ? <div className="divider" style={{ height: '51px' }}></div> : null}
            </div>
            {isEdit ?
                <Paper square style={{ padding: '10px', borderTop: '1px solid #d7d7d7', position: 'absolute', bottom: '0', left: '0', width: '100%', background: '#fff', zIndex: 9 }}>
                    <ul className='list-inline' style={{ textAlign: 'right' }}>
                        <li className='list-inline-item'>
                            <Button onClick={() => { setError(''); setEdit(false); getWeightDetails() }} color='primary' variant='outlined' size='small'>Cancel</Button>
                        </li>
                        <li className='list-inline-item'>
                            <Button onClick={editWeightDetails} color='primary' variant='contained' size='small'>Save</Button>
                        </li>
                    </ul>
                </Paper> : null
            }
            {isLoading ? <PageLoader /> : null}
        </div>
    )
}
export default withRouter(AircraftWeight);